import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import axios from 'axios'
import cignalLogo from '../../assets/cignal-logo.png'


const initialValues = {
    // personal
    email: "",
    isManagingCommunity: "",
    EthereumAddressOrENS: ""
  };
  
  const validationSchema = Yup.object({
   email: Yup.string().email('invalid email').optional(),
   isManagingCommunity: Yup.string().max(155).required('required'),
   EthereumAddressOrENS: Yup.string().max(155).optional(),
  });
  

const JoinWaitlist = () => {
  
    const [isGood, setGood] = useState(false)
    const onSubmit = async (data) => {
        await axios
        .post('join-waitlist', data)
        .then(() => {
            setGood(true)
        }) 
        .catch((error) => {
        if (error.response || error.request) {
          alert(JSON.stringify(error.response.data.message));
         }
        })
        }

        if(isGood) {
          return <h1 className="text-white font-semibold text-center text-2xl p-10">You're on our waitlist! keep an eye on your email to be notified on all things cignal 😉.</h1>
            
        }

        return (
          <div className="w-full shadow-lg rounded-lg max-w-xs mx-auto my-10 p-5 bg-white">
             <div className="flex flex-col justify-center mb-10">
             <img className='mx-auto'  width={100} height={100}  src={cignalLogo} alt="cignal-logo" />
                       <h1 className='text-2xl mt-3 text-black flex-initial text-center mx-auto'>Join Waitlist</h1>
                        </div>
                      
           <Formik
              initialValues={initialValues}
             onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
               <Form className="w-full max-w-sm flex flex-col">
      {/* --------------------------------email------------------------------- */}
        <div className="flex flex-col py-2 mb-3">
        <p className="text-sm text-black pb-1">Email</p>
        <p className="text-xs text-black pb-1">We need this to contact you - but it's optional</p>
        <ErrorMessage name="email">
                  { msg => <div className="mb-1 text-red-600 text-xs">{msg}</div> }
                  </ErrorMessage>
          <Field className="flex-auto shadow appearance-none border rounded w-full text-gray-700  mr-3 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" 
          type="email"
          id="inputEmail"
          name="email" 
          />
        </div>

          {/* -------------------------------isManagingCommunity------------------------------- */}
          <div className="flex flex-col py-2 mb-3">
        <p className="text-sm text-black pb-1">Do you own or manage a community?<span className='text-red-600'> *</span></p>
        <p className="text-xs text-black pb-1">If so, what is the name?</p>
        <p className="text-xs text-black pb-1">If no, enter 'N/A'</p>
        <ErrorMessage name="isManagingCommunity">
                  { msg => <div className="mb-1 text-red-600 text-xs">{msg}</div> }
                  </ErrorMessage>
          <Field className="flex-auto shadow appearance-none border rounded w-full text-gray-700  mr-3 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" 
          type="text"
          id="inputIsManagingCommunity"
          name="isManagingCommunity" />
        </div>

        {/* -------------------------------EthereumAddressOrENS------------------------------- */}
        <div className="flex flex-col py-2 mb-3">
        <p className="text-sm text-black pb-1">Ethereum Address or ENS</p>
        <p className="text-xs text-black pb-1">We'll airdrop you an early access NFT :)</p>
        <ErrorMessage name="EthereumAddressOrENS">
                  { msg => <div className="mb-1 text-red-600 text-xs">{msg}</div> }
                  </ErrorMessage>
          <Field className="flex-auto shadow appearance-none border rounded w-full text-gray-700  mr-3 py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" 
          type="text"
          id="inputEthereumAddressOrENS"
          name="EthereumAddressOrENS" />
        </div>
      
      
        <button className="btn my-5 flex-shrink-0 bg-black text-sm text-white py-1 px-2 rounded w-40 mx-auto transition w-60 ease-in-out  bg-white hover:-translate-y-1 hover:scale-110 duration-300 " type="submit">
            Join
          </button>
      
      
        </Form>
              </Formik>
              </div>
        )
}


export default JoinWaitlist